<template>
  <el-container style="width: 100%;height: 100%;display: flex;flex-direction: column;">
    <el-row style="width: 100%; height: 48px;margin-bottom: 1px;background-color: #ffffff;">
      <el-menu default-active="1" class="horizontal-menu" @select="menuSelect"
               mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(0, 0, 0, 1)">
        <template v-for="sub in energyItem">
          <el-menu-item class="horizontal-menu-item" :key="sub.id" :index="sub.id">
            <span style="font-size: 14px;">{{sub.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-row>
    <el-row style="width: 100%;height: calc(100% - 49px);display: flex;flex-direction: row;">
      <el-aside style="height: 100%;width: 250px;margin-right: 1px;overflow: hidden;background-color: #ffffff;">
        <el-row class="doc-tree-top">
          <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-row>
        <el-tree :data="treeData" :props="defaultProps" :filter-node-method="filterNode" node-key='id'
                 :default-expanded-keys="expandKeys" ref="tree" class="aside-tree" show-checkbox :default-checked-keys="checkedKey">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <i v-if="node.data.type === '1'" class="zy-icon-building"></i>
            <i v-if="node.data.type === '2'" class="zy-icon-commit"></i>
            <i v-if="node.data.type === '3'" class="zy-icon-sensor"></i>
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-aside>
      <el-main style="overflow-y: hidden;font-size: 14px;width: calc(100% - 251px);height: 100%;background-color: #ffffff;">
        <el-row class="tt-input" style="width: 100%;height: 48px;line-height: 48px;color: rgb(127, 127, 127);text-align: left;">
          <span style="margin-left: 24px;">起止日期：</span>
          <el-date-picker v-model="startDate" style="width: 138px;margin-left: 4px;"
                          placeholder="选择日期" value-format="yyyy-MM-dd" :clearable="false"/>
          <span>-</span>
          <el-date-picker v-model="endDate" style="width: 138px;margin-left: 4px;"
                          placeholder="选择日期" :clearable="false" value-format="yyyy-MM-dd"/>
          <el-button class="search-btn-blue" style="margin-left: 14px;" @click="getChartData(selNode)" type="primary" size="mini">查询</el-button>
          <el-button class="search-btn-blue" style="margin-left: 20px;" @click="toExcel" type="primary" size="mini">导出</el-button>
        </el-row>
        <el-row style="background-color: #fff;width: 100%; height: 1px;"></el-row>
        <el-row style="overflow: hidden;height: calc(100% - 49px);width: 100%;" class="table">
          <el-table :span-method="objectSpanMethod" border fit :data="tableData" height="calc(100% - 32px)" width='100%' ref="tableData">
            <el-table-column v-for="(item,i) in tableProps" :key="i"
              :prop="item.prop" :label="item.label" width="item.width">
              <el-table-column v-if='item.props' v-for="(prop,j) in item.props" :key="j"
                :prop="prop.prop" :label="prop.label" width="prop.width">
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-pagination style='height:32px;background-color: #FFFFFF;text-align: left;width: 100%;' @current-change="handlePageChange" @size-change="handleSizeChange"
                         :current-page='currPageNo' :page-size="pageSize" :total="total"
                         layout="total, sizes, prev, pager, next, jumper" :page-sizes="[18,36,54,72,90]"
                         background/>
        </el-row>
      </el-main>
    </el-row>
  </el-container>
</template>

<script>
import {Message} from "element-ui";
import DateUtils from "../../../utils/DateUtils";
import * as axios from "axios";
export default {
  name: "ExpenseReport",
  data() {
    return {
      selNode: '',
      treeData: [],
      expandKeys: [],
      checkedKey: '',
      defaultProps: {
        children: 'childNode',
        label: 'name'
      },
      startDate: DateUtils.getYesterday().Format('yyyy-MM-dd'),
      endDate: DateUtils.getYesterday().Format('yyyy-MM-dd'),
      tableProps: [
        {prop: "sensorName", label: "测量点"},
        {prop: "totalEnergy", label: "总电量(KWh)", width: 15},
        {prop: "totalExpense", label: "总电费(元)"},
        {prop: "minData", label: "尖", props: [{prop: "tipEnergy", label: "尖电量(KWh)"}, {prop: "tipExpense", label: "尖电费(元)"}]},
        {prop: "minTime", label: "峰", props: [{prop: "topEnergy", label: "峰电量(KWh)"}, {prop: "topExpense", label: "峰电费(元)"}]},
        {prop: "avgData", label: "平", props: [{prop: "normEnergy", label: "平电量(KWh)"}, {prop: "normExpense", label: "平电费(元)"}]},
        {prop: "maxData", label: "谷", props: [{prop: "botEnergy", label: "谷电量(KWh)"}, {prop: "botExpense", label: "谷电费(元)"}]}
      ],
      tableData: [],
      nameList: [],
      idList: [],
      currPageNo: 1,
      pageSize: this.GlobalConfig.PAGE_SIZE_18,
      total: 0,
      nodeType: '3',
      nodeId: '',
      energyItem: [{'id': '1', 'name': '电'}],
      unit: 'kWh',
      media: '1',
      filterName: ''
    }
  },
  created() {
    this.getTree('1')
    this.props = this.tableProps
  },
  watch: {
    filterName(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    menuSelect(val) {
      this.tableData = []
      this.chartData = []
      this.media = val
      this.getTree(val)
      if (val === '1') {
        this.unit = 'kWh'
      } else {
        this.unit = 'm³'
      }
    },
    getTree(val) {
      this.$api.systemManage.getSensorTree(val).then(res => {
        this.treeData = res.data
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0]);
          this.checkedKey = this.selNode.id.split(',')
          this.$refs.tree.setCheckedKeys([this.selNode['id']], true)
          let nodeIdName = 'id';
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1);
            this.getChartData()
          })
        }
      })
    },
    filterNode(value, data) {
      if (!value) return true;
      return data['name'].indexOf(value) !== -1;
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }
      return leafNode;
    },
    handlePageChange(pageNo) {
      this.currPageNo = pageNo;
      this.getChartData();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.getChartData();
    },
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    getChartData() {
      let params = {'id': this.$refs.tree.getCheckedKeys().join(","), 'startDate': this.startDate, 'endDate': this.endDate, page: this.currPageNo,
        rows: this.pageSize, type: this.nodeType, mediaId: '1'}
      this.$api.energyReport.getExpenseForm(params).then(res => {
        this.tableData = res.data.rows
        this.total = res.data.total;
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    toExcel() {
      let param = []
      param.push(this.startDate)
      param.push(this.endDate)
      param.push(this.$refs.tree.getCheckedKeys().join(","));
      param.push(this.nodeType);
      param.push('1');
      let paramStr;
      paramStr = '/energyReport/expenseForm' + '/exportExcel?searchData=' + param.join('_');
      paramStr += '_' + sessionStorage.getItem('token');
      window.open(axios.defaults.baseURL + paramStr);
    }
  }
}
</script>

<style scoped>
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  .table /deep/ .el-table th {
    background-color: rgba(2, 124, 247, 0.2);
    border-top: 0;
  }
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/FormManage/ExpenseReport.vue